import PropTypes from 'prop-types';
import { Link as RouterLink } from 'react-router-dom';
// @mui
import { useTheme } from '@mui/material/styles';
import { Box } from '@mui/material';

// -----------------------------------------------------------

Logo.propTypes = {
	disabledLink: PropTypes.bool,
	sx: PropTypes.object,
};

export default function Logo({ disabledLink = false, sx }) {
	const theme = useTheme();
	const PRIMARY_LIGHT = theme.palette.primary.light;
	const PRIMARY_MAIN = theme.palette.primary.main;
	const PRIMARY_DARK = theme.palette.primary.dark;
	const logo = (
		<Box sx={{ width: 40, height: 40, ...sx }}>
			<svg xmlns="http://www.w3.org/2000/svg" width="100%" height="100%"  viewBox="0 0 720.000000 721.000000">
				<defs>
					<linearGradient id="BG1" x1="100%" x2="50%" y1="9.946%" y2="50%">
						<stop offset="0%" stopColor={PRIMARY_DARK} />
						<stop offset="100%" stopColor={PRIMARY_MAIN} />
					</linearGradient>
					<linearGradient id="BG2" x1="50%" x2="50%" y1="0%" y2="100%">
						<stop offset="0%" stopColor={PRIMARY_LIGHT} />
						<stop offset="100%" stopColor={PRIMARY_MAIN} />
					</linearGradient>
					<linearGradient id="BG3" x1="50%" x2="50%" y1="0%" y2="100%">
						<stop offset="0%" stopColor={PRIMARY_LIGHT} />
						<stop offset="100%" stopColor={PRIMARY_MAIN} />
					</linearGradient>
				</defs>
				<g
					fill={PRIMARY_MAIN} stroke="none" strokeWidth="1" fillRule="evenodd"  transform="translate(0.000000,721.000000) scale(0.100000,-0.100000)" >
				<path d="M1755 3950 l-370 -370 373 -373 372 -372 372 372 373 373 -370 370
c-203 203 -372 370 -375 370 -3 0 -172 -167 -375 -370z m625 -70 l0 -50 -145
0 -145 0 0 -75 0 -75 125 0 125 0 0 -50 0 -50 -125 0 -125 0 0 -130 0 -130
-60 0 -60 0 0 305 0 305 205 0 205 0 0 -50z"/>
<path d="M1470 3993 l0 -248 245 245 c135 135 245 246 245 247 0 2 -110 3
-245 3 l-245 0 0 -247z"/>
<path d="M2540 3995 c135 -135 246 -245 247 -245 2 0 3 110 3 245 l0 245 -247
0 -248 0 245 -245z"/>
<path d="M3956 4051 c-3 -5 -54 -132 -112 -283 -58 -150 -108 -279 -111 -286
-4 -10 9 -12 58 -10 l64 3 21 60 21 60 123 0 122 0 23 -60 22 -60 66 -3 66 -3
-118 293 -117 293 -61 3 c-34 2 -64 -1 -67 -7z m104 -238 c19 -54 37 -101 38
-105 2 -5 -33 -8 -78 -8 -62 0 -81 3 -78 13 3 6 20 54 38 105 18 50 35 92 39
92 3 0 22 -44 41 -97z"/>
<path d="M4564 4050 c-60 -19 -126 -73 -158 -129 -24 -45 -31 -68 -34 -136 -8
-151 47 -255 160 -306 95 -42 249 -28 342 32 l46 29 0 120 0 120 -130 0 -130
0 0 -50 0 -50 70 0 70 0 0 -41 c0 -39 -1 -41 -56 -66 -67 -30 -126 -28 -178 8
-53 36 -69 73 -74 164 -3 69 0 86 20 124 29 57 64 82 121 88 64 7 115 -12 139
-53 23 -39 20 -38 88 -23 45 10 50 13 44 32 -14 48 -54 95 -100 118 -54 26
-185 36 -240 19z"/>
<path d="M3280 3755 l0 -295 60 0 60 0 0 125 0 125 125 0 125 0 0 50 0 50
-125 0 -125 0 0 70 0 70 145 0 145 0 0 50 0 50 -205 0 -205 0 0 -295z"/>
<path d="M5030 3755 l0 -295 225 0 225 0 0 50 0 50 -165 0 -165 0 0 80 0 80
150 0 150 0 0 50 0 50 -150 0 -150 0 0 65 0 65 160 0 160 0 0 50 0 50 -220 0
-220 0 0 -295z"/>
<path d="M5590 3755 l0 -295 50 0 50 0 0 191 c0 104 4 188 8 185 5 -3 60 -89
123 -190 l114 -186 58 0 57 0 0 295 0 295 -55 0 -55 0 -2 -190 -3 -190 -115
190 -115 189 -57 1 -58 0 0 -295z"/>
<path d="M1470 3165 l0 -245 247 0 248 0 -245 245 c-135 135 -246 245 -247
245 -2 0 -3 -110 -3 -245z"/>
<path d="M2615 3248 c-88 -90 -196 -200 -240 -245 l-80 -83 248 0 247 0 0 245
c0 135 -3 245 -8 245 -4 0 -79 -73 -167 -162z"/>
<path d="M3250 3185 l0 -115 49 0 c97 0 136 34 136 121 0 77 -39 109 -130 109
l-55 0 0 -115z m134 69 c21 -21 30 -58 21 -91 -11 -46 -33 -63 -82 -63 l-43 0
0 85 0 85 44 0 c27 0 51 -6 60 -16z"/>
<path d="M3568 3203 c-54 -140 -52 -133 -35 -133 9 0 20 15 27 35 11 34 13 35
61 35 46 0 49 -2 63 -35 8 -19 22 -35 30 -35 14 0 13 6 -3 48 -60 151 -75 182
-90 182 -11 0 -28 -31 -53 -97z m71 20 c8 -21 16 -44 18 -50 4 -9 -6 -13 -29
-13 -19 0 -37 2 -40 5 -6 6 24 95 32 95 3 0 12 -17 19 -37z"/>
<path d="M3802 3288 c3 -7 21 -14 41 -16 l37 -3 0 -100 c0 -81 3 -99 15 -99
12 0 15 18 15 99 l0 100 37 3 c20 2 38 9 41 16 3 9 -20 12 -93 12 -73 0 -96
-3 -93 -12z"/>
<path d="M4108 3203 c-54 -140 -52 -133 -35 -133 9 0 20 15 27 35 11 34 13 35
61 35 46 0 49 -2 63 -35 8 -19 22 -35 30 -35 14 0 13 6 -3 48 -60 151 -75 182
-90 182 -11 0 -28 -31 -53 -97z m71 20 c8 -21 16 -44 18 -50 4 -9 -6 -13 -29
-13 -19 0 -37 2 -40 5 -6 6 24 95 32 95 3 0 12 -17 19 -37z"/>
<path d="M4536 3279 c-50 -40 -29 -78 58 -103 57 -17 69 -30 54 -58 -17 -34
-118 -18 -118 18 0 9 -5 14 -11 12 -6 -2 -10 -7 -10 -11 1 -4 1 -14 1 -23 0
-17 57 -44 93 -44 37 0 77 36 77 70 0 33 -19 47 -90 65 -38 9 -45 15 -45 36 0
21 5 24 42 27 34 2 45 -1 55 -17 16 -26 28 -27 28 -1 0 22 -46 50 -83 50 -13
0 -36 -9 -51 -21z"/>
<path d="M4790 3185 l0 -115 85 0 c69 0 85 3 85 15 0 12 -14 15 -70 15 l-70 0
0 35 0 35 65 0 c51 0 65 3 65 15 0 12 -14 15 -65 15 l-65 0 0 35 0 35 70 0
c56 0 70 3 70 15 0 12 -16 15 -85 15 l-85 0 0 -115z"/>
<path d="M5070 3185 c0 -96 3 -115 15 -115 11 0 15 12 15 50 l0 50 35 0 c31 0
39 -6 67 -50 20 -30 40 -50 52 -50 18 0 18 1 1 28 -10 15 -29 39 -43 55 -20
21 -22 27 -10 27 25 0 48 28 48 60 0 43 -32 60 -112 60 l-68 0 0 -115z m124
85 c18 -7 26 -17 26 -34 0 -28 -16 -36 -76 -36 l-44 0 0 40 c0 39 1 40 34 40
19 0 46 -4 60 -10z"/>
<path d="M5350 3291 c0 -6 19 -58 42 -116 29 -75 46 -105 57 -103 8 2 31 44
52 96 52 127 53 132 36 132 -9 0 -26 -34 -47 -92 -18 -51 -36 -96 -39 -100 -4
-4 -22 37 -41 92 -19 56 -40 100 -47 100 -7 0 -13 -4 -13 -9z"/>
<path d="M5650 3185 c0 -96 3 -115 15 -115 12 0 15 19 15 115 0 96 -3 115 -15
115 -12 0 -15 -19 -15 -115z"/>
<path d="M5844 3285 c-36 -19 -54 -52 -54 -101 0 -100 104 -152 171 -85 16 16
29 34 29 40 0 19 -20 12 -44 -16 -17 -19 -32 -26 -57 -25 -45 1 -69 31 -69 87
0 78 63 116 118 70 34 -28 42 -31 42 -12 0 42 -85 68 -136 42z"/>
<path d="M6090 3185 l0 -115 85 0 c69 0 85 3 85 15 0 12 -14 15 -70 15 l-70 0
0 35 0 35 65 0 c51 0 65 3 65 15 0 12 -14 15 -65 15 l-65 0 0 35 0 35 70 0
c56 0 70 3 70 15 0 12 -16 15 -85 15 l-85 0 0 -115z"/>
<path d="M2330 1437 c-57 -18 -126 -95 -145 -162 -21 -70 -15 -119 22 -193 22
-44 25 -57 15 -73 -21 -33 -14 -38 51 -37 34 0 88 -3 120 -7 110 -14 206 39
253 139 57 123 -3 278 -128 330 -43 18 -136 19 -188 3z m186 -36 c72 -33 124
-117 124 -203 0 -53 -48 -138 -97 -172 -63 -44 -144 -48 -218 -12 -203 100
-132 407 94 406 33 0 73 -8 97 -19z"/>
<path d="M2331 1314 c-19 -14 -22 -22 -16 -53 14 -74 71 -137 153 -165 37 -13
43 -13 57 0 38 38 0 81 -61 69 -29 -5 -38 -2 -59 21 -28 30 -31 45 -13 73 9
15 8 24 -5 45 -20 30 -25 31 -56 10z"/>
<path d="M2841 1343 c-37 -31 -46 -145 -17 -215 10 -23 58 -40 90 -32 39 9 56
51 56 134 0 66 -2 74 -29 101 -34 33 -69 37 -100 12z m67 -35 c18 -18 16 -152
-3 -168 -29 -24 -45 5 -45 84 0 65 10 96 30 96 3 0 11 -5 18 -12z"/>
<path d="M3010 1335 c0 -24 3 -25 56 -25 l56 0 -17 -26 c-23 -36 -55 -131 -55
-166 0 -21 5 -28 19 -28 14 0 21 12 29 54 11 56 53 149 72 161 5 3 10 17 10
31 0 24 -2 24 -85 24 -84 0 -85 0 -85 -25z"/>
<path d="M3264 1350 c-29 -11 -44 -59 -44 -136 0 -73 23 -110 75 -120 63 -12
104 66 89 170 -10 78 -57 112 -120 86z m57 -47 c21 -24 19 -138 -3 -159 -14
-14 -20 -15 -32 -4 -12 9 -16 32 -16 84 0 87 20 118 51 79z"/>
<path d="M3464 1337 c-51 -44 -51 -180 1 -224 36 -31 70 -29 106 6 31 31 37
67 17 104 -23 44 -70 61 -96 35 -18 -18 -16 23 2 48 13 16 18 17 33 6 31 -21
44 -25 54 -15 14 14 1 39 -27 52 -37 17 -60 14 -90 -12z m80 -123 c17 -45 -4
-91 -37 -78 -39 15 -33 94 7 94 13 0 27 -7 30 -16z"/>
<path d="M3665 1336 c-41 -41 -45 -169 -7 -216 28 -33 74 -36 108 -7 28 24 29
29 29 112 0 83 -1 88 -28 111 -36 30 -71 31 -102 0z m75 -35 c15 -29 12 -134
-4 -157 -14 -18 -15 -18 -33 -1 -24 24 -26 153 -3 167 22 14 28 12 40 -9z"/>
<path d="M3867 1347 c-3 -8 -8 -39 -12 -70 -8 -63 -1 -69 49 -46 36 17 58 -3
54 -49 -4 -48 -33 -65 -58 -34 -30 37 -72 24 -51 -16 27 -51 126 -48 150 4 14
30 14 79 1 103 -11 22 -64 45 -85 37 -10 -4 -15 1 -15 14 0 17 7 20 50 20 47
0 50 2 50 25 0 24 -2 25 -64 25 -44 0 -65 -4 -69 -13z"/>
<path d="M4075 1348 c-2 -7 -8 -37 -13 -66 -11 -62 -1 -72 48 -52 39 16 60 0
60 -44 0 -55 -34 -72 -69 -35 -21 23 -51 20 -51 -4 0 -26 40 -52 82 -52 69 0
108 70 77 139 -13 27 -60 52 -84 42 -10 -4 -15 1 -15 14 0 17 7 20 50 20 47 0
50 2 50 25 0 24 -2 25 -65 25 -44 0 -67 -4 -70 -12z"/>
<path d="M4293 1348 c-12 -6 -26 -24 -32 -39 -9 -26 -8 -29 10 -29 12 0 29 10
38 21 12 16 23 20 39 15 40 -13 28 -52 -38 -123 -33 -35 -60 -73 -60 -83 0
-18 7 -20 85 -20 84 0 85 0 85 25 0 23 -4 25 -45 25 -52 0 -56 10 -18 40 65
51 81 113 38 155 -26 27 -64 31 -102 13z"/>
<path d="M4488 1340 c-71 -55 -12 -178 68 -142 23 11 24 10 18 -16 -12 -49
-47 -71 -60 -37 -7 17 -54 21 -54 5 0 -21 49 -60 75 -60 36 0 82 48 90 94 9
43 -1 115 -18 137 -31 41 -81 49 -119 19z m71 -34 c7 -8 11 -27 9 -43 -2 -21
-9 -29 -27 -31 -13 -2 -28 2 -32 10 -29 45 17 104 50 64z"/>
<path d="M4742 1340 c-7 -12 -24 -26 -37 -32 -16 -7 -25 -19 -25 -35 0 -27 3
-28 35 -7 l25 16 0 -96 c0 -96 0 -96 25 -96 l25 0 0 135 c0 122 -2 135 -18
135 -9 0 -23 -9 -30 -20z"/>
<path d="M4905 1336 c-41 -41 -45 -169 -7 -216 28 -33 74 -36 108 -7 28 24 29
29 29 112 0 83 -1 88 -28 111 -36 30 -71 31 -102 0z m75 -35 c15 -29 12 -134
-4 -157 -14 -18 -15 -18 -33 -1 -24 24 -26 153 -3 167 22 14 28 12 40 -9z"/>

</g>
</svg>


		</Box >
	);
	if (disabledLink) {
		return <>{logo}</>;
	}

	return <RouterLink to="">{logo}</RouterLink>;
}
